/* Copyright 2014-2020 The MathWorks, Inc. */

/**
 * This defines a mapping between the type of control and the properties associated with it.
 * A property can be marked as required and a default value can also be assigned to it.
 */

define([
    "dojo/_base/lang",
    "MW/statusbar/TypeConstants",
    "MW/toolstrip/hashes/PeerNodeWidgetPropertiesHash",
    "MW/statusbar/hashes/PeerNodeWidgetPropertiesHash"
], function (lang, TypeConstants, ToolstripPeerNodeWidgetPropertiesHash, StatusBarPeerNodeWidgetPropertiesHash) {
    
    var hash = {};

    lang.mixin(hash, ToolstripPeerNodeWidgetPropertiesHash);
    lang.mixin(hash, StatusBarPeerNodeWidgetPropertiesHash);

    Object.keys(hash).forEach(function (key) {
        Object.keys(hash[key]).forEach(function (prop) {
            hash[key][hash[key][prop]] = prop;
        });
    });

    return hash;
});